import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { XMarkIcon } from "@heroicons/react/24/outline";
import RequirementsPanel from "./RequirementsPanel";

/**
 * Requirements documents for a collection, in a dialog opened from the sidebar.
 *
 * Mounted lazily, same reasoning as CollectionReviewModal: a sidebar full of collections should
 * not fire a fetch per collection on every page load.
 */
const RequirementsModal = ({ open, onClose, collectionId, collectionName }) => {
  const userDetails = localStorage.getItem("userDetail");
  const companyId = userDetails ? JSON.parse(userDetails)?.companyid : null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle
        sx={{
          fontSize: 16,
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: 1,
          borderBottom: "1px solid #e5e7eb",
          py: 1.5,
        }}
      >
        <span>Requirements</span>
        {collectionName && (
          <span style={{ fontSize: 13, fontWeight: 400, color: "#6b7280" }}>{collectionName}</span>
        )}
        <IconButton onClick={onClose} size="small" sx={{ ml: "auto" }} aria-label="Close requirements">
          <XMarkIcon className="h-5 w-5" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: "#f9fafb", p: 2.5 }}>
        {open && <RequirementsPanel collectionId={collectionId} companyId={companyId} />}
      </DialogContent>
    </Dialog>
  );
};

export default RequirementsModal;
